import { useMemo } from "react";

import { usePreferenceValue } from "@/hooks/use-preference-value";
import { useGetOrganizationPolicies } from "@/queries/organization-queries";
import { parsePreviousOrgPolicyValue } from "@/utils/auto-delete";

const AUTO_DELETE_ARCHIVED_ENVIRONMENTS_AFTER = "DELETE_ARCHIVED_ENVIRONMENTS_AFTER";
const PREVIOUS_AUTO_DELETE_POLICY_VALUE = "PREVIOUS_AUTO_DELETE_POLICY_VALUE";

/**
 * Custom hook that provides parsed auto-delete values from organization policies and user preferences
 */
export const useAutoDeleteValues = () => {
    const { data: organizationPolicies } = useGetOrganizationPolicies();
    const { value: userPreferenceRaw } = usePreferenceValue(AUTO_DELETE_ARCHIVED_ENVIRONMENTS_AFTER);
    const { value: previousAutoDeletePolicyValueRaw, setValue: setPreviousAutoDeletePolicyValue } = usePreferenceValue(
        PREVIOUS_AUTO_DELETE_POLICY_VALUE,
    );

    return useMemo(() => {
        const currentOrgPolicySeconds = organizationPolicies?.deleteArchivedEnvironmentsAfter?.seconds;
        const currentAutoDeletePolicyValue =
            typeof currentOrgPolicySeconds === "bigint" ? Number(currentOrgPolicySeconds) : 0;

        const userPreferenceValue = typeof userPreferenceRaw === "string" ? parseInt(userPreferenceRaw, 10) || 0 : 0;

        const previousAutoDeletePolicyValue = parsePreviousOrgPolicyValue(previousAutoDeletePolicyValueRaw);

        return {
            userPreferenceValue,
            currentAutoDeletePolicyValue,
            previousAutoDeletePolicyValue,
            setPreviousAutoDeletePolicyValue,
            organizationPolicies,
        };
    }, [organizationPolicies, userPreferenceRaw, previousAutoDeletePolicyValueRaw, setPreviousAutoDeletePolicyValue]);
};
